import { cn } from '@/utils/styles';
import { Card } from '@design-system/Card';
import { Skeleton } from '@design-system/Skeleton';
import { List, ListItem } from '@design-system/List';
import { useUserDetails } from '@/hooks/useUserDetails';

export interface SettingsPageAccountSectionProps
  extends React.ComponentProps<'div'> {
  className?: string;
}

type IUserData = {
  label: string;
  value?: string | number;
  isLoading?: boolean;
};

const renderUserData = (userData: IUserData[]) => {
  const renderedUserData = userData.map((data) => (
    <ListItem key={data.label} hideIndicator>
      {data.label}

      {data.isLoading ? (
        <Skeleton className="ml-auto w-full h-4 max-w-24" />
      ) : (
        <span className="ml-auto text-secondary truncate">
          <abbr title={String(data.value)} className="no-underline">
            {data.value}
          </abbr>
        </span>
      )}
    </ListItem>
  ));

  return renderedUserData;
};

export const SettingsPageAccountSection = ({
  className,
}: SettingsPageAccountSectionProps) => {
  const { fullName, firstName, lastName, email } = useUserDetails();
  const fullNameLoading = !fullName || !firstName || !lastName;
  const emailLoading = !email;

  const userData = [
    {
      label: 'Name',
      value: fullName || `${firstName} ${lastName}`.trim(),
      isLoading: fullNameLoading,
    },
    {
      label: 'Email',
      value: email,
      isLoading: emailLoading,
    },
  ] satisfies IUserData[];

  return (
    <div className={cn('flex flex-col', className)}>
      <span className="typography-h2 text-primary mb-6">Account</span>

      <div className="flex flex-col gap-2">
        <Card className="overflow-hidden">
          <List>{renderUserData(userData)}</List>
        </Card>
      </div>
    </div>
  );
};
